import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  StringValuesjqid5a6cuday as StringValues,
  get3oezx9z3zutmm as get,
  forEachghjt92rkrpzo as forEach,
  StringValuesBuilderImpl3ey9etj3bwnqf as StringValuesBuilderImpl,
  StringValuesImpl2l95y9du7b61t as StringValuesImpl,
} from '../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Empty_1 = EmptyParameters_instance;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ParametersClass;
function Parameters() {
  if (ParametersClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Parameters', VOID, VOID, [StringValues()]);
    ParametersClass = $;
  }
  return ParametersClass;
}
var EmptyParametersClass;
function EmptyParameters() {
  if (EmptyParametersClass === VOID) {
    class $ {
      get_caseInsensitiveName_ehooe5_k$() {
        return true;
      }
      getAll_ffxf4h_k$(name) {
        return null;
      }
      names_1q9mbs_k$() {
        return emptySet();
      }
      entries_qbkxv4_k$() {
        return emptySet();
      }
      isEmpty_y1axqb_k$() {
        return true;
      }
      toString() {
        return 'Parameters ' + toString(this.entries_qbkxv4_k$());
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Parameters()) : false) {
          tmp = other.isEmpty_y1axqb_k$();
        } else {
          tmp = false;
        }
        return tmp;
      }
    }
    protoOf($).get_6bo4tg_k$ = get;
    protoOf($).forEach_jocloe_k$ = forEach;
    initMetadataForObject($, 'EmptyParameters', VOID, VOID, [Parameters()]);
    EmptyParametersClass = $;
  }
  return EmptyParametersClass;
}
var EmptyParameters_instance;
function EmptyParameters_getInstance() {
  return EmptyParameters_instance;
}
function ParametersBuilder(size) {
  size = size === VOID ? 8 : size;
  return new (ParametersBuilderImpl())(size);
}
var ParametersBuilderImplClass;
function ParametersBuilderImpl() {
  if (ParametersBuilderImplClass === VOID) {
    class $ extends StringValuesBuilderImpl() {
      constructor(size) {
        size = size === VOID ? 8 : size;
        super(true, size);
      }
      build_1k0s4u_k$() {
        return new (ParametersImpl())(this.values_1);
      }
    }
    initMetadataForClass($, 'ParametersBuilderImpl', ParametersBuilderImpl);
    ParametersBuilderImplClass = $;
  }
  return ParametersBuilderImplClass;
}
var ParametersImplClass;
function ParametersImpl() {
  if (ParametersImplClass === VOID) {
    class $ extends StringValuesImpl() {
      constructor(values) {
        values = values === VOID ? emptyMap() : values;
        super(true, values);
      }
      toString() {
        return 'Parameters ' + toString(this.entries_qbkxv4_k$());
      }
    }
    initMetadataForClass($, 'ParametersImpl', ParametersImpl, VOID, [Parameters()]);
    ParametersImplClass = $;
  }
  return ParametersImplClass;
}
//region block: init
EmptyParameters_instance = new (EmptyParameters())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance25cbdbruarm2m,
  ParametersBuilder as ParametersBuilder1ry9ntvvg567r,
};
//endregion

//# sourceMappingURL=Parameters.mjs.map
